import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { CurrentEmpresa } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityCurrentEmpresaLoadRequest = createAction(
  '[ENTITYCURRENTEMPRESA] Load Request',
  props<{ item: CurrentEmpresa }>()
);

export const entityCurrentEmpresaLoadFailure = createAction(
  '[ENTITYCURRENTEMPRESA] Load Failure',
  props<{ error: Error }>()
);

export const entityCurrentEmpresaLoadSuccess = createAction(
  '[ENTITYCURRENTEMPRESA] Load Success',
  props<{ item: CurrentEmpresa }>()
);

// ADD
export const entityCurrentEmpresaAddRequest = createAction(
  '[ENTITYCURRENTEMPRESA] Add Request',
  props<{ item: CurrentEmpresa }>()
);

export const entityCurrentEmpresaAddFailure = createAction(
  '[ENTITYCURRENTEMPRESA] Add Failure',
  props<{ error: Error }>()
);

export const entityCurrentEmpresaAddSuccess = createAction(
  '[ENTITYCURRENTEMPRESA] Add Success',
  props<{ item: CurrentEmpresa }>()
);

// CHANGE
export const entityCurrentEmpresaChangeRequest = createAction(
  '[ENTITYCURRENTEMPRESA] Change Request',
  props<{ item: CurrentEmpresa }>()
);

export const entityCurrentEmpresaChangeFailure = createAction(
  '[ENTITYCURRENTEMPRESA] Change Failure',
  props<{ error: Error }>()
);

export const entityCurrentEmpresaChangeSuccess = createAction(
  '[ENTITYCURRENTEMPRESA] Change Success',
  props<{ item: Update<CurrentEmpresa> }>()
);

// DELETE
export const entityCurrentEmpresaDeleteRequest = createAction(
  '[ENTITYCURRENTEMPRESA] Delete Request',
  props<{ item: CurrentEmpresa }>()
);

export const entityCurrentEmpresaDeleteFailure = createAction(
  '[ENTITYCURRENTEMPRESA] Delete Failure',
  props<{ error: Error }>()
);

export const entityCurrentEmpresaDeleteSuccess = createAction(
  '[ENTITYCURRENTEMPRESA] Delete Success',
  props<{ item: CurrentEmpresa }>()
);

// SET EMPTY
export const entityCurrentEmpresaSetEmpty = createAction(
  '[ENTITYCURRENTEMPRESA] Set empty'
);
